/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Personalsettingstitle2Inputs */

const en_settings_personalsettingstitle2 = /** @type {(inputs: Settings_Personalsettingstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select how you would like your dashboard to display: light, dark, or follow your computer's settings`)
};

/**
* | output |
* | --- |
* | "Select how you would like your dashboard to display: light, dark, or follow your computer's settings" |
*
* @param {Settings_Personalsettingstitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_personalsettingstitle2 = /** @type {((inputs?: Settings_Personalsettingstitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Personalsettingstitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_personalsettingstitle2(inputs)
});
export { settings_personalsettingstitle2 as "settings_personalSettingsTitle" }